export enum AppRatingAction {
    UserNavigated = "app-rating:user-navigated",
    OrderIsConfirmed = "app-rating:order-is-confirmed",
    ShowRatingPopup = "app:show-store-rating-popup",
    HideRatingPopup = "app:hide-store-rating-popup",
}

export interface BaseAppRatingCreatorReturn {
    type: AppRatingAction
}

export const userNavigated = (): BaseAppRatingCreatorReturn => {
    return {
        type: AppRatingAction.UserNavigated,
    }
}

export const orderIsConfirmed = (): BaseAppRatingCreatorReturn => {
    return {
        type: AppRatingAction.OrderIsConfirmed,
    }
}

export const showRatingPopup = (): BaseAppRatingCreatorReturn => {
    return {
        type: AppRatingAction.ShowRatingPopup,
    }
}

export const hideRatingPopup = (): BaseAppRatingCreatorReturn => {
    return {
        type: AppRatingAction.HideRatingPopup,
    }
}
